<template>
  <v-dialog
    v-model="opened"
    content-class="debt-edit"
    max-width="350"
    persistent
  >
    <h3 class="debt-edit__title">
      {{ $t('common.table.duty') }}
    </h3>

    <v-btn class="close-btn" icon @click="opened = false">
      <v-icon size="27" color="#464646"> mdi-close-circle-outline </v-icon>
    </v-btn>

    <v-form ref="debtEdit" :disabled="loading" @submit.prevent="onSubmit">
      <v-text-field
        v-model="amount"
        outlined
        dense
        :label="$t('common.fields.sum')"
        :rules="[isRequired, onlyNumbers]"
      />

      <v-text-field
        v-model="comment"
        outlined
        dense
        :label="$t('common.fields.comment')"
      />

      <v-btn
        color="warning"
        elevation="0"
        type="submit"
        block
        :loading="loading"
      >
        {{ $t('common.btns.save') }}
      </v-btn>
    </v-form>
  </v-dialog>
</template>

<script>
export default {
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    loading: false,
    amount: '',
    comment: '',
  }),
  watch: {
    opened(val) {
      if (!val) {
        this.$refs.debtEdit.reset();
      } else {
        this.amount = Number(this.item.driver_debt).toString();
        this.comment = this.item.driver_debt_comment;
      }
    },
  },
  computed: {
    opened: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('change', val);
      },
    },
  },
  methods: {
    isRequired(v) {
      return !!v || this.$t('common.fields.validation.field.required');
    },
    onlyNumbers(v) {
      if (!v) return true;
      return (
        /^[0-9]{1,12}$/.test(v) || this.$t('common.fields.validation.numbers')
      );
    },
    async onSubmit() {
      const isValid = this.$refs.debtEdit.validate();

      if (!isValid) return;

      this.loading = true;

      const res = await this.$store.dispatch('workers-board/updateItem', {
        id: this.item.id,
        formData: {
          car_id: this.item.car_id,
          driver_id: this.item.driver_id,
          driver_debt: this.amount,
          driver_debt_comment: this.comment,
        },
      });

      this.$emit('updated', { res, id: this.item.id });
      this.loading = false;
    },
  },
};
</script>

<style lang="scss">
.debt-edit {
  padding: 10px 15px;
  background-color: #fff;

  &__title {
    color: #484848;
    font-size: 18px;
    margin-bottom: 15px;
  }
}
</style>
